import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { http } from "@/lib/api";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

export default function HomeHeader({ data }) {
  const navigate = useNavigate();
  const name = data.user.first_name || "Player";
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    http.get("/messages/unread-count").then((r) => setUnread(r.data.unread)).catch(() => {});
    const onMsg = () => setUnread((n) => n + 1);
    window.addEventListener("pv:message", onMsg);
    return () => window.removeEventListener("pv:message", onMsg);
  }, []);

  return (
    <div className="flex items-center justify-between pt-1" data-testid="home-header">
      <div className="flex items-center gap-3">
        <Avatar className="h-12 w-12 border-2 pv-border-primary" data-testid="header-avatar">
          <AvatarImage src={data.user.avatar} alt={name} />
          <AvatarFallback>{name[0]}</AvatarFallback>
        </Avatar>
        <div>
          <h1 className="text-2xl font-black font-display pv-text-dark leading-tight" data-testid="header-greeting">
            {data.greeting}, {name}
          </h1>
          <p className="text-sm text-[#5C7285]">Ready to play?</p>
        </div>
      </div>
      <button
        data-testid="messages-button"
        onClick={() => navigate("/messages")}
        className="relative grid place-items-center h-10 w-10 rounded-full bg-white border border-[#0E395F]/10 text-[#0E395F] hover:bg-[#0E395F] hover:text-white transition-colors"
        title="Messages"
      >
        <MessageSquare size={18} />
        {unread > 0 && (
          <span className="absolute -top-1 -right-1 h-5 w-5 grid place-items-center rounded-full bg-[#F5B700] text-black text-[10px] font-black">
            {unread}
          </span>
        )}
      </button>
    </div>
  );
}
